  <section id="paging" class="mb-3"   *ngIf="CanShow === 1 ">

    <div class="row">
      <div class="col-12">
        <div *ngIf="CurrentActorEmpHistoryInfoController">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-10 pink">
                  <i class="fa fa-institution"></i> EMPLOYMENT HISTORY
                </div>
                <div class="col-md-2 float-right"    *ngIf="CanEdit === 1 ">
                  <a (click)="openNewContent()"><span class="badge badge-pink"> <i class="fa fa-plus"></i></span></a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="card-block">
                <div *ngFor="let l of CurrentActorEmpHistoryInfoController">
                  <div class="media mb-1">
                    <div class="media-body">
                      <h4 class="font-medium-1 mt-1 mb-1">{{l.FromDate | date:'dd-MMM-yyyy'}} - {{l.ToDate | date:'dd-MMM-yyyy'}}</h4>
                      <p class="text-muted font-small-3 pink">{{l.EmployerName}}</p>
                      <p class="text-muted font-small-2">{{l.Duties}}</p>
                    </div>
                    <div class="mt-1">
                      <div class="row">
                        <!--<div class="float-left">-->
                        <a (click)="OpenDetailContent(l.EmpHistoryCode)">
                          <span class="badge">
                            <i class="fa fa-list grey"></i>
                          </span>
                        </a>
                        <a (click)="openDocContent(l.ActorDocCode)">
                          <span class="badge">
                            <i class="fa fa-file grey"></i>
                          </span>
                        </a>
                        <a (click)="del_(l.EmpHistoryCode)"    *ngIf="CanEdit === 1 ">
                          <span class="badge">
                            <i class="fa fa-times grey"></i>
                          </span>
                        </a>
                        <!--</div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="row">
      <div class="col-sm-12">
        <data-grid *ngIf="CurrentActorEmpHistoryInfoController"
                   [columns]="columns" [data]="CurrentActorEmpHistoryInfoController"
                   [gridbtns]="gridbtns"
                   [hdrbtns]="hdrbtns"
                   [sort]="sorting"
                   (btnclick)="gridaction($event)">
        </data-grid>

      </div>
    </div>-->
  </section>
  <!--Paging dataTable starts-->


  <div *ngIf="CanShowRegistryView === 1 && CurrentActorEmpHistoryInfoController && CurrentActorEmpHistoryInfoController.length >0">
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
        <div class="row">
          <div class="col-12">
            <div *ngIf="CurrentActorEmpHistoryInfoController">
              <div class="card">
                <div class="card-header   wh-header">
                  <div class="row">
                    <div class="col-md-10 pink ">
                      <i class="fa fa-institution"></i> EMPLOYMENT HISTORY
                    </div>
                   
                  </div>
                </div>
                <div class="card-body">
                  <div class="card-block">
                    <div *ngFor="let l of CurrentActorEmpHistoryInfoController">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>{{l.FromDate | date:'dd-MMM-yyyy'}} - {{l.ToDate | date:'dd-MMM-yyyy'}}</label>
                            <p>{{l.EmployerName}}</p>
                            <p>{{l.Duties}}</p>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
